/**
 * 区分 jobStatus（jobs.job_status）
 * 出典：02 D-092
 */
export const JOB_STATUS_VALUES = ['waitingUpload', 'queued', 'running', 'succeeded', 'failed'] as const;

export type JobStatus = (typeof JOB_STATUS_VALUES)[number];

export const JOB_STATUS_LABELS: Readonly<Record<JobStatus, string>> = {
  waitingUpload: 'アップロード待ち',
  queued: '待機中',
  running: '実行中',
  succeeded: '完了',
  failed: '失敗',
};
